<script setup lang="ts">
import { MUButton } from "@xlabmedical/medic-web-framework";
import { useWindowSize } from "@vueuse/core";
import { computed, ref } from "vue";

type ProjectItemContextMenuItem = {
    label: string;
    icon?: string;
    command?: () => void;
    disabled?: boolean;
    checked?: boolean;
};

interface Props {
    hasWeblinkOrder: boolean;
    hideProjectItemButtonLabels: boolean;
    isProjectActionDisabled: boolean;
    itemsExtra: Array<{ items: ProjectItemContextMenuItem[] }>;
}

const props = defineProps<Props>();

const menuOpenExtra = ref<{ toggle: (event: Event) => void } | null>(null);
const { width } = useWindowSize();
const actionIconSize = computed(() => (width.value <= 768 ? "1.375rem" : "2rem"));

const toggleExtraMenu = (event: Event) => {
    if (props.isProjectActionDisabled) {
        return;
    }

    menuOpenExtra.value?.toggle(event);
};
</script>

<template>
    <span
        v-if="!hasWeblinkOrder"
        aria-haspopup="true"
        aria-controls="overlay_menu_open"
        @click="toggleExtraMenu"
        v-tooltip="hideProjectItemButtonLabels ? $t('weblink.extra') : null">
        <MUButton
            :label="hideProjectItemButtonLabels ? undefined : $t('weblink.extra')"
            :iconSrcHeight="actionIconSize"
            :iconSrcWidth="actionIconSize"
            :iconAbove="true"
            :iconSrc="'/icons/rg_settings2.svg'"
            style="height: 60px !important"
            :background="false"
            :disabled="isProjectActionDisabled" />
    </span>
    <Menu v-if="!hasWeblinkOrder" ref="menuOpenExtra" id="overlay_menu_open" :model="itemsExtra" :popup="true">
        <template #item="{ item, props }">
            <a v-bind="props.action" :class="['flex items-center gap-2', item.checked ? 'extra-menu-item-checked' : '']">
                <span class="extra-menu-item-icon">
                    <i v-if="item.checked" class="pi pi-check" />
                    <i v-else-if="item.icon && item.icon.startsWith('pi ')" :class="item.icon" />
                    <img v-else-if="item.icon" :src="item.icon" alt="" class="w-5 h-5" style="margin-left: -0.15rem" />
                </span>
                <span>{{ item.label }}</span>
            </a>
        </template>
    </Menu>
</template>

<style scoped>
.extra-menu-item-icon {
    width: 1.25rem;
    min-width: 1.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.extra-menu-item-checked {
    background: #4d9fe9;
}
</style>
